import { render, staticRenderFns } from "./MenuPrimary.vue?vue&type=template&id=5c8901de&"
import script from "./MenuPrimary.vue?vue&type=script&lang=js&"
export * from "./MenuPrimary.vue?vue&type=script&lang=js&"
import style0 from "./MenuPrimary.vue?vue&type=style&index=0&id=5c8901de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports